import styled from 'styled-components';

export const InputContainer = styled.div`
border: 1px #E5E5E5 solid;
border-radius: 4px;
padding: 16px 10px;
display: flex;
flex-flow: row wrap;
align-items: flex-start;
align-content: flex-start;
gap: 15px;

&.focus{
    border-color: #196FE0;
}

`

export const Input = styled.input`
border: none;
margin-left: 5px;
font-size: 14px;
color: #566672;
line-height: 18px;
&:focus{
    outline: none;
}
&::-webkit-input-placeholder { /* Chrome/Opera/Safari */
    color: rgba(86,102,114,0.6);
}

`

export const Tag = styled.span`
background: #ECEFF6;
border-radius: 23px;
font-family: "Open Sans", sans-serif;
font-size: 12px;
line-height: 20px;
color: #4D596C;
display: flex;
align-items: center;
padding-left: 10px;
padding-right: 10px;

& svg{
    width: 8px;
    height: 8px;
    margin-left: 5px;
}

`

export const CloseButton = styled.button`
border: none;
background-color: transparent;
width: 8px;
height: 8px;
display: flex;
align-items: center;
justify-content: center;
cursor: pointer;
`
